<template>
  <div class="search-card-loader">
    <v-img
      src="/img/gradient-image-loader.png"
      :aspect-ratio="16/10"
    >
      <div class="moving-gradient image-gradient" />
    </v-img>
    <div class="loading-title" />
    <div class="detail-container">
      <div v-for="i in 3" :key="i" class="loading-detail moving-gradient" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columnType: {
      type: String,
      default: 'text'
    }
  }
}
</script>

<style lang="sass" scoped>
.search-card-loader
  width: 100%
  margin-bottom: 1.5rem
  background: $hwayzWhite
  position: relative
  text-decoration: none

.image-gradient
  height: 100%
  opacity: 0.5
  animation-duration: 1s

.loading-title
  height: 7.8rem
  background: $hwayzec

.detail-container
  padding: 16px
  width: 100%

.loading-detail
  height: 2rem
  margin: 0.8rem
  animation-duration: 1s

.moving-gradient
  background: linear-gradient(to right, #f2f2f2 20%, #fafafa 50%, #f2f2f2 80%)
  background-size: 20rem 10rem
  animation-name: moving-gradient
  animation-iteration-count: infinite
  animation-timing-function: linear
  animation-fill-mode: forwards

@keyframes moving-gradient
  0%
    background-position: -10rem 0
  100%
    background-position: 10rem 0

@-webkit-keyframes moving-gradient
  0%
    background-position: -10rem 0
  100%
    background-position: 10rem 0
</style>
